/** All possible return options. */
export enum LabelOption {
  ShippingLabel = 'ShippingLabel',
  QRCode = 'QRCode'
}
